import laptopHappyFace from '../assets/laptop-happy-face.png'

type FullScreenError = {
  message?: string
  header?: string
}

const FullscreenError: React.FC<FullScreenError> = ({
  message = 'Oops, an error occurred. Please refresh to continue.',
  header,
}) => {
  return (
    <div className="min-h-screen flex flex-col justify-center items-center">
      {header && <h1 className="pb-4 text-xl font-bold">{header}</h1>}
      <img
        className="w-[192px] h-[111px]"
        alt="laptop-happy-face"
        src={laptopHappyFace}
      />
      <p className="text-center font-SF mt-6 text-[#aaaaaa] text-sm">
        {message}
      </p>
    </div>
  )
}

export default FullscreenError
